import { jsxs as f, jsx as l } from "react/jsx-runtime";
const n = ({ className: e, width: o = "36", height: c = "36" }) => /* @__PURE__ */ f(
  "svg",
  {
    className: e,
    width: o,
    height: c,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    fill: "none",
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          d: "M0 18c0 9.941 8.059 18 18 18s18-8.059 18-18S27.941 0 18 0 0 8.059 0 18Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M26.32 23.77c-.443-.367-2.66-2.2-3.162-2.318-.444-.367-.695-.426-1.063.012-.368.437-1.606 1.194-1.974 1.631-.31.19-.56.13-1.063.012-.443-.367-1.832-1.218-3.43-3.43-1.214-1.596-1.809-3.57-1.943-4.126-.133-.556.176-.745.486-.934l.928-.568c.31-.189.368-.437.678-.627.31-.189.117-.496.175-.744.059-.249-.36-2.968-.628-4.08-.075-.804-.578-.922-.829-.981l-1.004-.237c-.25-.06-.753-.177-1.372.2-.619.38-2.166 1.325-2.751 3.808-.586 2.483.645 5.132.779 5.687.192.308 2.226 6.291 6.778 9.46 3.858 2.744 4.728 2.425 5.732 2.662 1.004.236 3.305-.532 3.79-1.466.794-1.123 1.029-2.116.777-2.176.042-1.3-.46-1.418-.903-1.785Z",
          fill: "#fff"
        }
      )
    ]
  }
);
export {
  n as default
};
